<template>
	<div class="layer-project" data-project-name="premium-food-market">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">Lotte Premium Food Market</h1>
					<a href="http://www.lottefoodmarket.com" class="link" target="_blank"
						>www.lottefoodmarket.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						더 신선한, 더 건강한, 더 기분좋은
						<span class="ib">푸드 라이프 스타일을 누릴 수 있는 곳이라는</span>
						콘셉트의
						<span class="ib">롯데 프리미엄 푸드마켓을 구축했습니다.</span>
						<br />푸드 라이프 스타일을 선도하는 주체로서 보다 건강하고 신선한
						제품과 정성이 담긴 서비스로 고객의 식문화의 변화를 일으킨다는 콘셉트
						아래,
						<span class="break"
							>신선한 제품의 이미지를 전달하고 매장을 소개함으로써 새롭게
							런칭하는 롯데 프리미엄 푸드마켓의 소개를 담고 있습니다.</span
						>
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram">
							<li class="item01">Healthy Life Style</li>
							<li class="item02">Convenient &amp; Fun</li>
							<li class="item03">Best Fresh &amp; Taste</li>
							<li class="item04">Various Types</li>
							<li class="item05">Trend Leading</li>
							<li class="item06">Lotte Premium Food Market</li>
						</ul>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section section01">
				<div class="inner-section">
					<div class="pc-web-info">
						<strong class="project-subtit">PC Web</strong>
						<p class="sub-text">
							상단의 키 비주얼 영역은 롯데 프리미엄 푸드마켓의 홍보영상을
							배치하여 브랜드의 이미지를 부각시켰으며,
							<span
								>하단에는 식품 카테고리로 바로 이동 가능한 배너를 실사 이미지와
								아이콘으로 표현하고 직관성을 강조하여 구성했습니다.</span
							>
						</p>
					</div>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/premium-food-market/pc-web-img-01@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section section02">
				<div class="inner-section">
					<div class="life-style">
						<strong class="life-title">Food Life Style</strong>
						<div class="life-text">
							더 신선한, 더 건강한, 더 기분 좋은
							<span class="ib">푸드 라이프 스타일을</span> 누구나 누릴 수 있는
							곳, <span class="ib">롯데 프리미엄 푸드마켓</span>
						</div>
					</div>
				</div>
			</section>
			<section class="section section03">
				<div class="inner-section clfix">
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/premium-food-market/pc-web-img-03@m.png"
						/>
					</div>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/premium-food-market/pc-web-img-04@m.png"
						/>
					</div>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/premium-food-market/pc-web-img-05@m.png"
						/>
					</div>
				</div>
			</section>

			<section class="section full section04">
				<div class="inner-section">
					<strong class="project-subtit">Mobile <span>Web</span></strong>
				</div>
			</section>
			<section class="section section05">
				<div class="inner-section">
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/premium-food-market/mobile-web-img@m.png"
						/>
					</div>
				</div>
			</section>

			<section class="section full section06">
				<div class="inner-section">
					<div class="img-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/premium-food-market/point-img@m.png"
							/>
						</div>
					</div>
					<div class="icon-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/premium-food-market/point-icon@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">Lotte Premium Food Market</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.project-visual > div {
	padding-top: 30px;
}
.project-tit {
	text-transform: uppercase;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.project-visual .project-tit {
		font-size: 5.337vw;
	}
	.project-visual .project-tit + .link {
		font-size: 1.9662vw;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual .project-tit {
		font-size: 70px;
	}
	.project-visual .project-tit + .link {
		font-size: 19px;
	}
	.project-visual > div {
		padding-top: 130px;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/premium-food-market/ci.png) 50% /
		auto 80px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/premium-food-market/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/premium-food-market/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 100px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/premium-food-market/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 199px;
	}
}

/* Overview */
.project-overview {
	background-color: #da242c;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 15px;
}
.project-overview-diagram ul {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
}
.project-overview-diagram li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 28.125vw;
	height: 28.125vw;
	margin: 15px 0;
	padding: 10px;
	border-radius: 50%;
	border: 1px dashed #fff;
	line-height: 1.7rem;
	text-align: center;
	background-color: #de1d24;
}
.project-overview-diagram .item06 {
	overflow: hidden;
	white-space: nowrap;
	text-indent: -9999px;
	font-size: 0;
	background: #fff
		url(/static/img/project-detail/premium-food-market/diagram-logo.png) 50% 50%
		no-repeat;
	border: 0;
	background-size: 42.5px auto;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.project-overview-diagram ul {
		justify-content: center;
	}
	.project-overview-diagram li {
		width: 90px;
		height: 90px;
	}
	.project-overview-diagram li + li {
		margin-left: 15px;
	}
	.project-overview-diagram .item06 {
		margin-left: 30px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-txt .break {
		display: block;
	}
	.project-overview-diagram li {
		width: 190px;
		height: 190px;
		padding: 45px;
		font-size: 20px;
		line-height: 1.5;
	}
	.project-overview-diagram li + li {
		margin-left: 10px;
	}
	.project-overview-diagram .item05 {
		position: relative;
	}
	.project-overview-diagram .item05:after {
		content: "";
		position: absolute;
		top: 50%;
		right: -43px;
		width: 30px;
		height: 2px;
		background-color: #fff;
	}
	.project-overview-diagram .item06 {
		margin-left: 57px;
		background-size: 85px auto;
	}
}

.section01 {
	background: #e5e5e5
		url(/static/img/project-detail/premium-food-market/pc-web-bg@m.png)
		no-repeat;
	background-size: 100% auto;
}
.section.section01 {
	padding-bottom: 0;
}
.section01 .img {
	text-align: center;
}
.pc-web-info {
	color: #fff;
}
.pc-web-info .sub-text {
	margin-bottom: 35px;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section01 {
		background-image: url(/static/img/project-detail/premium-food-market/pc-web-bg@t.png);
	}
	.section01 .img {
		width: 88.764044vw;
		max-width: 990px;
		margin: 0 auto;
		text-align: right;
	}
	.section01 .img img {
		width: 75.9129vw;
	}
}
@media screen and (min-width: 1280px) {
	.section.section01 {
		padding-left: 0;
		padding-right: 0;
		background-size: 1920px 770px;
		background-position: top center;
	}
	.section01 {
		background-image: url(/static/img/project-detail/premium-food-market/pc-web-bg@w.png);
	}
	.section01 .img {
		position: relative;
		width: 100%;
		max-width: none;
		height: 2117px;
		margin: 0;
		text-align: left;
	}
	.section01 .img img {
		position: absolute;
		top: 0;
		left: 80px;
		width: 1368px;
		max-width: none;
	}
	.pc-web-info {
		margin-bottom: 80px;
	}
	.pc-web-info .sub-text {
		font-size: 16px;
		line-height: 1.8;
	}
	.pc-web-info .sub-text span {
		display: block;
	}
}
.section02 {
	background: url(/static/img/project-detail/premium-food-market/pc-web-img-02@m.png)
		50% 100% no-repeat;
	background-size: 84.375vw auto;
}
.section02 .inner-section {
	padding-bottom: 85px;
}
.life-style {
	text-align: center;
}
.life-title {
	display: block;
	margin-bottom: 20px;
	font-size: 2.5rem;
}
.life-text {
	width: 290px;
	margin: 0 auto;
	line-height: 1.5;
	word-break: keep-all;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section02 {
		background-image: url(/static/img/project-detail/premium-food-market/pc-web-img-02@t.png);
		background-size: 42.0646vw auto;
	}
	.section02 .inner-section {
		padding-top: 10px;
		padding-bottom: 75px;
	}
	.life-title {
		font-size: 2.5rem;
	}
	.life-text {
		width: 315px;
	}
}
@media screen and (min-width: 1280px) {
	.section02 {
		background-image: url(/static/img/project-detail/premium-food-market/pc-web-img-02@w.png);
		background-size: auto auto;
	}
	.section02 .inner-section {
		padding-top: 80px;
		padding-bottom: 260px;
	}
	.life-title {
		margin-bottom: 10px;
		font-size: 46px;
	}
	.life-text {
		width: 360px;
		line-height: 1.8;
	}
}

.section03 {
	position: relative;
	background-color: #ebebdf;
}
.section03:after {
	content: "";
	position: absolute;
	bottom: 20px;
	right: 0;
	width: 57.65625vw;
	height: 59.53125vw;
	background: url(/static/img/project-detail/premium-food-market/pc-web-img-06@m.png)
		no-repeat;
	background-size: 100% auto;
}
.section03 .inner-section {
	padding-bottom: 100px;
}
.section03 .img {
	text-align: center;
}
.section03 img {
	box-shadow: 0 22.5px 30px rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 711px) {
	.section03 .img + .img {
		margin-top: 20px;
	}
	.section03 img {
		width: 81.25vw;
	}
}
@media screen and (min-width: 712px) {
	.section03:after {
		width: 37.5vw;
		height: 29.70505vw;
		background-image: url(/static/img/project-detail/premium-food-market/pc-web-img-06@t.png);
	}
	.section03 .inner-section {
		padding: 0 35px;
	}
	.section03 .img {
		float: left;
		width: 36.51685vw;
	}
	.section03 .img:nth-child(2) {
		float: right;
	}
	.section03 .img:last-child {
		margin-top: 45px;
	}
}
@media screen and (min-width: 1280px) {
	.section.section03 {
		padding-left: 0;
		padding-right: 0;
	}
	.section03:after {
		left: calc(50% + 320px);
		right: auto;
		width: 606px;
		height: 469px;
		background-image: url(/static/img/project-detail/premium-food-market/pc-web-img-06@w.png);
	}
	.section03 .inner-section {
		padding-top: 140px;
		padding-bottom: 140px;
	}
	.section03 .img {
		width: 578px;
	}
}

.section.section04.full {
	padding: 0;
}
.section04 .inner-section {
	height: 109.84375vw;
	padding: 40px 15px;
	background: url(/static/img/project-detail/premium-food-market/mobile-web-bg@m.png)
		100% 0 no-repeat;
	background-size: 60.78125vw auto;
}
.section04 .project-subtit {
	line-height: 1.2;
}
@media screen and (max-width: 711px) {
	.section04 .project-subtit {
		width: 41vw;
	}
}
@media screen and (min-width: 712px) {
	.section04 .inner-section {
		height: 41.08146vw;
		padding: 45px 40px;
		background-image: url(/static/img/project-detail/premium-food-market/mobile-web-bg@t.png);
		background-position-x: calc(100% - 40px);
	}
}
@media screen and (min-width: 1280px) {
	.section04 .project-subtit {
		max-width: 1280px;
		padding-left: 20px;
		padding-right: 20px;
		margin: 0 auto;
	}
	.section04 .inner-section {
		height: 659px;
		padding: 45px 40px;
		background-image: url(/static/img/project-detail/premium-food-market/mobile-web-bg@w.png);
		background-size: auto auto;
		background-position-x: calc(50% + 175px);
	}
}

.section.section05 {
	padding-bottom: 0;
}
.section05 {
	background-color: #eeeeee;
}
.section05 .inner-section {
	padding-top: 5px;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section05 .inner-section {
		padding-top: 30px;
	}
	.section05 .img {
		width: 76.3342vw;
		margin: 0 auto;
	}
}
@media screen and (min-width: 1280px) {
	.section05 .inner-section {
		padding-top: 105px;
	}
	.section05 .img {
		width: 76.3342vw;
	}
}

.section06 {
	background: url(/static/img/project-detail/premium-food-market/point-bg@m.png)
		no-repeat;
	background-size: cover;
}
.img-area .img {
	width: 91.40625vw;
	margin: 0 auto;
}
.icon-area {
	padding: 0 15px;
	text-align: center;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section06 {
		background-image: url(/static/img/project-detail/premium-food-market/point-bg@t.png);
	}
	.section06 .inner-section {
		padding-top: 15px;
		padding-bottom: 10px;
	}
	.img-area .img {
		width: 95.435393vw;
		text-align: center;
	}
	.icon-area {
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.section06 {
		background-image: url(/static/img/project-detail/premium-food-market/point-bg@w.png);
	}
	.section06 .inner-section {
		padding-top: 110px;
		padding-bottom: 100px;
	}
	.img-area .img {
		width: 100%;
		max-width: 1341px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/premium-food-market.vue